import {
  FormControlLabel,
  FormControl,
  Checkbox,
  FormGroup,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  generaCommunicationsAndProductionCode,
  generaEnergyAndWaterIndustryCode,
  generaFinanceAndInsuranceCode,
  generalCircularEconomyCode,
  generalClimateChangeCode,
  generalEnergyCode,
  generalEnvironmentTrendsAndNewsCode,
  generaLifeAndLeisureServicesCode,
  generalManufacturingtCode,
  generalNatureConservationCode,
  generaLodgingAndFoodServicesCode,
  generalOrganizationAndSkillsKnowledge,
  generalOthersInterestCode,
  generalSocialTrendsCode,
  generalWorkAndLifePlanning,
  generaOtherIndustriesCode,
  generaSpecializedServicesConsultingCode,
  environmentalManagementJobs,
  carbonNeutralJobs,
  solarPowerJobs,
  energyBusinessJobs,
  energySavingEquipmentJobs,
  circularEconomyJobs,
  chemicalAndPollutionJobs,
  otherEnvironmentalJobs,
} from "../../../utils/constants/constant"
import Minus from "../../../components/svg/Minus";
import Plus from "../../../components/svg/Plus";
import ErrorMsg from "../../../components/Commons/ErrorMsg";

interface dataCheckbox {
  label: string;
  value: string;
}

const BasicInterests: React.FC<IInterstFormProps> = (props) => {
  const { t } = useTranslation();
  const { isEdit = true, onChangeData, userData, onChangeValidate, errorMess, id } = props;
  const [state, setState] = useState<IInterstFormState>({
    userMetaData: {
      interest: {
        jobCodes: [],
        environmentBusinessCodes: [],
        industoryCodes: [],
      },
    },
  });
  const { userMetaData } = state;
  const [visibleForms, setVisibleForms] = useState<boolean>(true);
  const [visibleJobCodes, setVisibleJobCodes] = useState<boolean>(true);
  const [visibleEnvironmentBusinessCodes, setVisibleEnvironmentBusinessCodes] = useState<boolean>(false);
  const [errors, setErrors] = useState({
    jobCodes: "",
    environmentBusinessCodes: "",
    industoryCodes: "",
  });

  useEffect(() => {
    if (errorMess && errorMess.length > 0) {
      errorMess.forEach((error) => {
        setErrors((prevErrors) => {
          if (error.field && Object.keys(prevErrors).includes(error.field)) {
            return {
              ...prevErrors,
              [error.field]: error.mess,
            };
          }
          return prevErrors;
        });
      });
    }
  }, [errorMess]);

  useEffect(() => {
    if (userData) {
      setState((prevState) => {
        const updatedInterest = {
          ...userData.interest,
          jobCodes: userData.interest?.jobCodes ?? [],
          environmentBusinessCodes: userData.interest?.environmentBusinessCodes ?? [],
          industoryCodes: userData.interest?.industoryCodes ?? [],
          jobChangeCode: userData.interest?.jobChangeCode ?? undefined,
        };
        if (userData.transition_source === "kankyobusiness") {
          if (!updatedInterest.jobCodes.includes("0102")) {
            updatedInterest.jobCodes = [...updatedInterest.jobCodes, "0102"];
          }
        }
  
        if (
          JSON.stringify(prevState.userMetaData) !== JSON.stringify({
            ...userData,
            interest: updatedInterest,
          })
        ) {
          return {
            ...prevState,
            userMetaData: {
              ...userData,
              interest: updatedInterest,
            },
          };
        }
        return prevState; 
      });
      if (userData.transition_source === "kankyobusiness") {
        setVisibleEnvironmentBusinessCodes(true);
        if (!isEdit) {
          setVisibleJobCodes(true);
        } else {
          setVisibleJobCodes(false);
        }
      } else if (!isEdit) {
        setVisibleEnvironmentBusinessCodes(true);
      }
    }
  }, [userData]);
  

  useEffect(() => {
    if (onChangeData) {
      onChangeData(userMetaData ?? {});
    }

    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
  }, [state]);


  const handleCountCurrentValid = () => {
    const fields = [
      {
        valid:
          userMetaData?.interest?.jobCodes &&
          userMetaData?.interest?.jobCodes?.length > 0,
      },
      // {
      //   valid:
      //     userMetaData?.interest?.environmentBusinessCodes &&
      //     userMetaData?.interest?.environmentBusinessCodes?.length > 0,
      // },
    ];

    return fields.reduce((currentValid, { valid }) => {
      return valid ? currentValid + 1 : currentValid;
    }, 0);
  };

  const handleChange =
    (field: keyof IInterest) =>
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        const value = event.target.value;

        setState((prevState) => {
          const currentCodes =
            (prevState.userMetaData?.interest?.[field] as string[]) ?? [];
          let updatedCodes: string[] = [];
          const fieldName = [
            "jobCodes",
            "environmentBusinessCodes",
          ];
          if (fieldName.includes(field)) {
            if (value === "0") {
              updatedCodes = checked ? ["0"] : [];
            } else {
              updatedCodes = checked
                ? [...currentCodes.filter((code) => code !== "0"), value]
                : currentCodes.filter((code) => code !== value);
            }
          } else {
            if (checked) {
              updatedCodes = [...currentCodes, value];
            } else {
              updatedCodes = currentCodes.filter((code) => code !== value);
            }
          }

          const transitionSource = userMetaData?.transition_source;

          if (Array.isArray(prevState.userMetaData?.interest?.[field])) {
            const shouldValidate =
              (transitionSource === "kankyobusiness" && field === "environmentBusinessCodes") ||
              (transitionSource !== "kankyobusiness" && field === "jobCodes");

            if (shouldValidate) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                [field]: updatedCodes.length === 0 ? t("common.required") : "",
              }));
            }
          }

          return {
            ...prevState,
            userMetaData: {
              ...prevState?.userMetaData,
              interest: {
                ...prevState.userMetaData?.interest,
                [field]: Array.isArray(prevState.userMetaData?.interest?.[field])
                  ? updatedCodes
                  : checked
                    ? value
                    : undefined,
              },
            },
          };
        });
      };

  const getFilteredLabelsJobCodes = (data: dataCheckbox[]) => {
    const filteredLabels = data
      .filter((item) => userMetaData?.interest?.jobCodes?.includes(item.value))
      .map((item) => item.label);

    if (filteredLabels.length === 0) {
      return <div>未選択</div>;
    }

    return filteredLabels.map((item, index) => <div key={index}>{item}</div>);
  };

  const getFilteredLabelsEnvironmentBusinessCodes = (data: dataCheckbox[]) => {
    const filteredLabels = data
      .filter((item) =>
        userMetaData?.interest?.environmentBusinessCodes?.includes(item.value)
      )
      .map((item) => item.label);

    if (filteredLabels.length === 0) {
      return <div>未選択</div>;
    }

    return filteredLabels.map((item, index) => <div key={index}>{item}</div>);
  };

  const getFilteredLabelsIndustoryCodes = (data: dataCheckbox[]) => {
    const filteredLabels = data
      .filter((item) =>
        userMetaData?.interest?.industoryCodes?.includes(item.value)
      )
      .map((item) => item.label);

    if (filteredLabels.length === 0) {
      return <div></div>;
    }

    return filteredLabels.map((item, index) => <div key={index}>{item}</div>);
  };

  return (
    <div id={id} className="component__basic-interests">
      <h3 className="basic-interests_title" onClick={() => isEdit && setVisibleForms(!visibleForms)} style={{ cursor: isEdit ? "pointer" : "default" }}>
        <img className="-icon" src="/images/ico_basic.svg" />
        {t("features.userSetting.basicInterests.basicInterestInformation")}
        {isEdit && (visibleForms ? <Minus /> : <Plus />)}
      </h3>
      {visibleForms ?
        <>
          <dl className="basic-interests_body">
            <div className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}>
              <dt className="-middle">
                <label className={`${isEdit ? "" : "pr0"}`} style={{ cursor: isEdit ? "pointer" : "default" }} onClick={() => isEdit && setVisibleJobCodes(!visibleJobCodes)}>
                  <span>
                    {" "}
                    {t("features.userSetting.basicInterests.topicInterest")}
                  </span>
                  {isEdit && userMetaData?.transition_source !== "kankyobusiness" && (
                    <span className="item_required">{t("general.required")}</span>
                  )}
                  <div className="item_icon">
                    {isEdit && (visibleJobCodes ? <Minus /> : <Plus />)}
                  </div>
                  
                </label>
              </dt>
              <dd>
                <div
                  className="-item_icon"
                  onClick={() =>
                    isEdit && setVisibleJobCodes(!visibleJobCodes)
                  }
                  style={{
                    cursor: isEdit ? "pointer" : "default",
                  }}
                >
                  {isEdit && (visibleJobCodes ? <Minus /> : <Plus />)}
                </div>
                <>
                  <div>
                    <div className={isEdit ? "txt-loud" : "txt-gray"}>
                      {visibleJobCodes ? t("features.userSetting.basicInterests.socialTrends") : ""}
                    </div>
                  </div>
                  {visibleJobCodes && (
                    <>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {generalSocialTrendsCode.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    checked={userMetaData?.interest?.jobCodes?.includes(
                                      item.value
                                    )}
                                    onChange={handleChange("jobCodes")}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        <>{getFilteredLabelsJobCodes(generalSocialTrendsCode)}</>
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.skillsAndCertifications"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {generalOrganizationAndSkillsKnowledge.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("jobCodes")}
                                    checked={userMetaData?.interest?.jobCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsJobCodes(generalOrganizationAndSkillsKnowledge)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.workStyleAndLifePlanning"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {generalWorkAndLifePlanning.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("jobCodes")}
                                    checked={userMetaData?.interest?.jobCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsJobCodes(generalWorkAndLifePlanning)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t("features.userSetting.basicInterests.others")}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontWeight: "normal",
                                  fontSize: 15,
                                },
                                "& .Mui-checked + .MuiFormControlLabel-label": {
                                  fontWeight: "bold",
                                },
                              }}
                              control={
                                <Checkbox
                                  value={0}
                                  checked={userMetaData?.interest?.jobCodes?.includes(
                                    "0"
                                  )}
                                  onChange={handleChange("jobCodes")}
                                  sx={{
                                    color: "#009999",
                                    "&.Mui-checked": {
                                      color: "#009999",
                                    },
                                    "& .MuiSvgIcon-root": {
                                      fontSize: "15px",
                                    },
                                  }}
                                />
                              }
                              label={t(
                                "features.userSetting.basicInterests.noneApplyJob"
                              )}
                            />
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsJobCodes([
                          {
                            value: "0",
                            label: t(
                              "features.userSetting.basicInterests.noneApplyJob"
                            ),
                          },
                        ])
                      )}
                      <ErrorMsg
                        error={errors.jobCodes}
                        className="invalid-danger"
                      />
                    </>
                  )}
                </>
              </dd>
            </div>
          </dl>
          {/* start */}
          <dl className="basic-interests_body">
            <div className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}>
              <dt className="-middle">
                <label className={`${isEdit ? "" : "pr0"}`} style={{ cursor: isEdit ? "pointer" : "default" }} onClick={() => isEdit && setVisibleEnvironmentBusinessCodes(!visibleEnvironmentBusinessCodes)}>
                  <span>
                    {" "}
                    {t("features.userSetting.basicInterests.interestedEnvironmentalTopics")}
                  </span>
                  {isEdit && userMetaData?.transition_source === "kankyobusiness" && (
                    <span className="item_required">{t("general.required")}</span>
                  )}
                  <div className="item_icon">
                     {isEdit && (visibleEnvironmentBusinessCodes ? <Minus /> : <Plus />)}
                  </div>
                </label>
              </dt>
              <dd>
                <div
                  className="-item_icon"
                  onClick={() =>
                    isEdit && setVisibleEnvironmentBusinessCodes(!visibleEnvironmentBusinessCodes)
                  }
                  style={{
                    cursor: isEdit ? "pointer" : "default",
                  }}
                >
                  {isEdit && (visibleEnvironmentBusinessCodes ? <Minus /> : <Plus />)}
                </div>
                <>
                  <div>
                    <div className={isEdit ? "txt-loud" : "txt-gray"}>
                      {visibleEnvironmentBusinessCodes ? t("features.userSetting.basicInterests.environmentalManagementJobs") : ""}
                    </div>
                  </div>
                  {visibleEnvironmentBusinessCodes && (
                    <>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {environmentalManagementJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        <>{getFilteredLabelsEnvironmentBusinessCodes(environmentalManagementJobs)}</>
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.carbonNeutralJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {carbonNeutralJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(carbonNeutralJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.solarPowerJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {solarPowerJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(solarPowerJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.energyBusinessJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {energyBusinessJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(energyBusinessJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.energySavingEquipmentJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {energySavingEquipmentJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(energySavingEquipmentJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.circularEconomyJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {circularEconomyJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(circularEconomyJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.chemicalAndPollutionJobs"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {chemicalAndPollutionJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(chemicalAndPollutionJobs)
                      )}

                      <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                        {t(
                          "features.userSetting.basicInterests.others"
                        )}
                      </div>
                      {isEdit ? (
                        <FormControl>
                          <Box display={"flex"} flexWrap="wrap">
                            {otherEnvironmentalJobs.map((item) => (
                              <FormControlLabel
                                key={item.value}
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontWeight: "normal",
                                    fontSize: 15,
                                  },
                                  "& .Mui-checked + .MuiFormControlLabel-label": {
                                    fontWeight: "bold",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    value={item.value}
                                    onChange={handleChange("environmentBusinessCodes")}
                                    checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                      item.value
                                    )}
                                    sx={{
                                      color: "#009999",
                                      "&.Mui-checked": {
                                        color: "#009999",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "15px",
                                      },
                                    }}
                                  />
                                }
                                label={item.label}
                              />
                            ))}
                          </Box>
                        </FormControl>
                      ) : (
                        getFilteredLabelsEnvironmentBusinessCodes(otherEnvironmentalJobs)
                      )}

                      <ErrorMsg
                        error={errors.environmentBusinessCodes}
                        className="invalid-danger"
                      />
                    </>
                  )}
                </>
              </dd>
            </div>
          </dl>

           {/* <dl className="basic-interests_body">
            <div className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}>
              <dt className="-middle">
                <label className={`${isEdit ? "" : "pr0"}`}>
                  <span>
                    {t(
                      "features.userSetting.basicInterests.interestedEnvironmentalTopics"
                    )}
                  </span>
                  {isEdit && (
                    <span className="item_required">{t("general.required")}</span>
                  )}
                </label>
              </dt>
              <dd>
                <>
                  <div className={isEdit ? "txt-loud" : "txt-gray"}>
                    {t("features.userSetting.basicInterests.climateChange")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalClimateChangeCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("environmentBusinessCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(
                      generalClimateChangeCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t("features.userSetting.basicInterests.energy")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalEnergyCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("environmentBusinessCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(generalEnergyCode)
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t("features.userSetting.basicInterests.circularEconomy")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalCircularEconomyCode.map((item) => (
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            key={item.value}
                            control={
                              <Checkbox
                                value={item.value}
                                onChange={handleChange("environmentBusinessCodes")}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(
                      generalCircularEconomyCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t("features.userSetting.basicInterests.natureConservation")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalNatureConservationCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("environmentBusinessCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(
                      generalNatureConservationCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.environmentalInterests"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalEnvironmentTrendsAndNewsCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("environmentBusinessCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(
                      generalEnvironmentTrendsAndNewsCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t("features.userSetting.basicInterests.others")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalOthersInterestCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.environmentBusinessCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("environmentBusinessCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsEnvironmentBusinessCodes(
                      generalOthersInterestCode
                    )
                  )}
                  {errors.environmentBusinessCodes && (
                    <div
                      className="error-text"
                      role="alert"
                      id="error-environment-business"
                    >
                      {errors.environmentBusinessCodes}
                    </div>
                  )}
                </>
              </dd>
            </div>
          </dl>

          <dl className="basic-interests_body">
            <div className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}>
              <dt className="-middle">
                <label>
                  <span>
                    {t("features.userSetting.basicInterests.industryOfInterest")}
                  </span>
                </label>
              </dt>
              <dd>
                <>
                  <div className={isEdit ? "txt-loud" : "txt-gray"}>
                    {t("features.userSetting.basicInterests.makeIndustry")}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generalManufacturingtCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(generalManufacturingtCode)
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.specializedServicesConsultingAndAgency"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generaSpecializedServicesConsultingCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(
                      generaSpecializedServicesConsultingCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.energyAndWaterIndustries"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl className="">
                      <Box display={"flex"} flexWrap="wrap">
                        {generaEnergyAndWaterIndustryCode.map((item) => (
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            key={item.value}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(
                      generaEnergyAndWaterIndustryCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.informationCommunicationAndProduction"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generaCommunicationsAndProductionCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(
                      generaCommunicationsAndProductionCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.financeAndInsuranceIndustry"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generaFinanceAndInsuranceCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(generaFinanceAndInsuranceCode)
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.hospitalityAndFoodServiceIndustry"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generaLodgingAndFoodServicesCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(
                      generaLodgingAndFoodServicesCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t(
                      "features.userSetting.basicInterests.lifestyleServicesAndEntertainment"
                    )}
                  </div>
                  {isEdit ? (
                    <FormControl>
                      <Box display={"flex"} flexWrap="wrap">
                        {generaLifeAndLeisureServicesCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            control={
                              <Checkbox
                                value={item.value}
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(
                      generaLifeAndLeisureServicesCode
                    )
                  )}

                  <div className={isEdit ? "txt-loud mt-2" : "txt-gray mt-2"}>
                    {t("features.userSetting.basicInterests.otherIndustries")}
                  </div>
                  {isEdit ? (
                    <FormControl className="mt-2">
                      <Box display={"flex"} flexWrap="wrap">
                        {generaOtherIndustriesCode.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            control={
                              <Checkbox
                                checked={userMetaData?.interest?.industoryCodes?.includes(
                                  item.value
                                )}
                                value={item.value}
                                onChange={handleChange("industoryCodes")}
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: 15,
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                            label={item.label}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  ) : (
                    getFilteredLabelsIndustoryCodes(generaOtherIndustriesCode)
                  )}
                </>
              </dd>
            </div>
          </dl> */}
        </>
        : ""}
    </div>
  );
};

export default BasicInterests;
